import styled from "styled-components";
import Grid from "@mui/material/Grid";
import { deviceSpec } from "breakpoints";
import Paper from "@mui/material/Paper";

export const StyledGridLayout = styled(Grid)`
  @media ${deviceSpec.isTablet} {
    display: grid !important;
    grid-template-columns: repeat(6, calc(50% - 27px));
    grid-template-rows: minmax(100px, 1fr);
    overflow-x: scroll;
  }
  
  gap: 1em;
`;

export const StyledTopContainer = styled(Paper)`
  background-color: ${({ theme }) => theme.colors.mediumGrey};
  color: ${({ theme }) => theme.colors.textColor};

  p {
    color: ${({ theme }) => theme.colors.textColor};
  }
`

export const StyledIcon = styled('div')`
  margin-left: 8px;
  display: flex;
  align-self: center;
`

export const StyledTopGridNumber = styled.div`
  font-weight: 400;
  font-size: 24px;
  padding-bottom: 6px;

  @media ${deviceSpec.isTablet} {
    font-weight: 400;
    font-size: 16px;
    line-height: 26px;
  }
`;

export const StyledTopGridType = styled.div`
  display: flex;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  padding-bottom: 6px;
  color: #d3d3d3;
  white-space: nowrap;

  @media ${deviceSpec.isTablet} {
    font-weight: 400;
    font-size: 12px;
    line-height: 22px;
    overflow: hidden;
  }
`;

export const MonitoredGridContainer = styled(Grid)({
  paddingTop: 32.5,
  paddingLeft: 24,
  fontWeight: "500",
  fontSize: "14px",
});

export const UnMonitoredGridContainer = styled(Grid)({
  paddingLeft: 24,
  paddingBottom: 25,
  paddingTop: 10,
  fontWeight: "500",
  fontSize: "14px",
});

export const MonitoredAssetGridItem = styled(Grid)({
  fontWeight: "600",
});
